import {
  SET_STORY_PERMISSION_CHECKS,
  SET_WORKSPACE_PERMISSION_CHECKS,
} from "../_actions/types";

const initialState = {
  workspacePermissionChecks: {},
  storyPermissionChecks: {},
  aiDocumentPermissionChecks: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_WORKSPACE_PERMISSION_CHECKS:
      return {
        ...state,
        workspacePermissionChecks: {
          ...state.workspacePermissionChecks,
          ...action.payload,
        },
      };
    case SET_STORY_PERMISSION_CHECKS:
      return {
        ...state,
        storyPermissionChecks: {
          ...action.payload,
        },
        workspacePermissionChecks: {
          ...state.workspacePermissionChecks,
          ...action.payload,
        },
      };
    default:
      return state;
  }
}
